import React from "react";
import './../../styles/tailwind-custom.css';
import { cn } from "../../lib/utils";
interface RainbowButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export function RainbowButton({
  children,
  className,
  ...props
}: RainbowButtonProps) {
  return (
    <button
      className={cn(
        "shiny-cta",
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
}
